/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '../types';

import type { FetchOptions } from "../fetcher/fetcher.types"
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, useMutation, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions, UseMutationOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher/index';
export type CachedSiteDataQueryVariables = Types.Exact<{
  language?: Types.InputMaybe<Types.Language>;
}>;


export type CachedSiteDataQuery = { __typename?: 'Query', cachedSiteData: { __typename?: 'SiteData', billing: boolean, currencies: { __typename?: 'SiteCurrencies', currencies: Array<{ __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }>, activeCurrency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string } }, allAccessYearlyBanner?: { __typename: 'AllAccessYearlyBanner', type: Types.SiteBannerType, yearly: boolean, buttonUrl: string, buttonText: string, showInHeader: boolean, backgroundImage: string, headline: string, features: Array<string>, bannerAboveNav: string, bannerAboveNavState: string, isHidden: boolean } | null, allAccessYearlyTrialBanner?: { __typename: 'AllAccessYearlyTrialBanner', type: Types.SiteBannerType, yearly: boolean, buttonUrl: string, buttonText: string, showInHeader: boolean, backgroundImage: string, headline: string, features: Array<string>, bannerAboveNav: string, bannerAboveNavState: string, isHidden: boolean } | null, promo: { __typename?: 'SitePromotions', promotion?: { __typename?: 'SitePromotion', discount: number, name: string } | null, takeover?: { __typename?: 'SiteTakeover', aboveNavBannerBtnColor: string, aboveNavBannerBtnTextColor: string, aboveNavBannerColor: string, aboveNavBannerImg: string, isActive: boolean } | null } } };

export type SiteDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SiteDataQuery = { __typename?: 'Query', siteData: { __typename?: 'SiteData', billing: boolean, isExtensionPopupEnabled: { __typename?: 'IsPropertyEnabled', enabled: boolean }, currencies: { __typename?: 'SiteCurrencies', currencies: Array<{ __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string }>, activeCurrency: { __typename?: 'Currency', code?: Types.CurrencyCode | null, symbol: string } }, productCounts: { __typename?: 'ProductCounts', fonts: number, crafts: number, graphics: number, embroidery: number }, newsletterPopup?: { __typename: 'NewsletterPopup', type: Types.SitePopupType, title: string, text: string, closeText: string, footerText: string, backgroundImageSrc: string, button: { __typename?: 'NewsletterPopupButton', backgroundColor: string, text: string, link?: string | null } } | null, notificationPopup?: { __typename: 'NotificationPopup', type: Types.SitePopupType, backgroundColor: string, title: string, textColor: string, text: string, closeText: string, button: { __typename?: 'NotificationPopupButton', backgroundColor: string, hoverBackgroundColor: string, text: string, textColor: string, hoverTextColor: string, link: string }, countdown?: { __typename?: 'SiteCountdown', text: string, value: string } | null } | null, profileNudgePopup?: { __typename: 'ProfileNudgePopup', type: Types.SitePopupType, title: string, text: string, button: { __typename?: 'ProfileNudgePopupButton', backgroundColor: string, text: string, link?: string | null } } | null, awaitingRenewalConfirmationBanner?: { __typename: 'AwaitingRenewalConfirmationBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, bannerAboveNav: string, bannerAboveNavState: string } | null, classesBanner?: { __typename: 'ClassesBanner', type: Types.SiteBannerType, text: string, fontSize: string, lineHeight: string, textColor: string, backgroundColor: string, bannerTitleClass: string, hideByDefault: boolean, button: { __typename?: 'ClassesBannerButton', backgroundColor: string, text: string, textColor: string, link: string } } | null, notificationBanner?: { __typename: 'NotificationBanner', type: Types.SiteBannerType, backgroundColor: string, textColor: string, text: string, bannerAboveNav: string, bannerAboveNavState: string, countdown?: { __typename?: 'SiteCountdown', text: string, value: string } | null, button: { __typename?: 'NotificationBannerButton', backgroundColor: string, hoverBackgroundColor: string, text: string, textColor: string, hoverTextColor: string, link: string } } | null, onHoldSubscriptionBanner?: { __typename: 'OnHoldSubscriptionBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, bannerAboveNav: string, bannerAboveNavState: string } | null, sparkFreeTrialBanner?: { __typename: 'SparkFreeTrialBanner', type: Types.SiteBannerType, backgroundImage: string, text: string, subtext: string, aboveButtonText: string, belowButtonText: string, buttonText: string, buttonUrl: string, bannerAboveNav: string, bannerAboveNavState: string, bannerIsMinimized: boolean } | null, allAccessBanner?: { __typename: 'AllAccessBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, textColor: string, bannerAboveNav: string, bannerAboveNavState: string, bannerAboveNavPromo: number, countdown?: { __typename?: 'SiteBannerCountdown', text: string, value: string } | null, button: { __typename?: 'AllAccessBannerButton', backgroundColor: string, text: string, textColor: string, hoverTextColor: string, link: string } } | null, undoCancelationBanner?: { __typename: 'UndoCancelationBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, subscriptionId: string, bannerAboveNav: string, bannerAboveNavState: string, button: { __typename?: 'UndoCancelationBannerButton', backgroundColor: string, text: string, textColor: string, hoverTextColor: string, onClick: string, link?: string | null }, countdown: { __typename?: 'SiteBannerCountdown', value: string, text: string } } | null, upsellBanner?: { __typename: 'UpsellBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, countdown: { __typename?: 'SiteBannerCountdown', text: string, value: string }, button: { __typename?: 'UpsellBannerButton', backgroundColor: string, text: string, textColor: string, hoverTextColor: string, link: string } } | null, verificationBanner?: { __typename: 'VerificationBanner', type: Types.SiteBannerType, backgroundColor: string, text: string, textColor: string, bannerAboveNav: string, bannerAboveNavState: string, button: { __typename?: 'VerificationBannerButton', backgroundColor: string, text: string, textColor: string, link: string } } | null, allAccessYearlyBanner?: { __typename: 'AllAccessYearlyBanner', type: Types.SiteBannerType, yearly: boolean, buttonUrl: string, buttonText: string, showInHeader: boolean, backgroundImage: string, headline: string, features: Array<string>, bannerAboveNav: string, bannerAboveNavState: string, isHidden: boolean } | null, allAccessYearlyTrialBanner?: { __typename: 'AllAccessYearlyTrialBanner', type: Types.SiteBannerType, yearly: boolean, buttonUrl: string, buttonText: string, showInHeader: boolean, backgroundImage: string, headline: string, features: Array<string>, bannerAboveNav: string, bannerAboveNavState: string, isHidden: boolean } | null, studioAiYearlyTrialBanner?: { __typename: 'StudioAiYearlyTrialBanner', type: Types.SiteBannerType, yearly: boolean, buttonUrl: string, buttonText: string, showInHeader: boolean, backgroundImage: string, headline: string, features: Array<string>, bannerAboveNav: string, bannerAboveNavState: string, isHidden: boolean, variant: string } | null, allAccessYearlyExtendBanner?: { __typename: 'AllAccessYearlyExtendBanner', type: Types.SiteBannerType, backgroundImage: string, buttonText: string, features: Array<string>, headline: string, subscriptionId: string, inProgress: boolean, lastOrderPaymentUrl: string, countdownDt?: string | null, bannerAboveNav: string, bannerAboveNavState: string } | null, promo: { __typename?: 'SitePromotions', promotion?: { __typename?: 'SitePromotion', discount: number, name: string } | null, takeover?: { __typename?: 'SiteTakeover', aboveNavBannerBtnColor: string, aboveNavBannerBtnTextColor: string, aboveNavBannerColor: string, aboveNavBannerImg: string, isActive: boolean } | null } } };

export type UpdateUserGdprConsentMutationVariables = Types.Exact<{
  input: Types.UserUpdateGdprInput;
}>;


export type UpdateUserGdprConsentMutation = { __typename?: 'Mutation', updateUserGDPR: { __typename?: 'UpdateUserResponse', success?: boolean | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type LegacyProductFetchProductQueryVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
}>;


export type LegacyProductFetchProductQuery = { __typename?: 'Query', legacyProductsFetchProduct?: { __typename?: 'LegacyProduct', id: number, title: string, image?: string | null, favoriteCount: number, author: { __typename?: 'LegacyAuthor', avatar?: string | null, name?: string | null }, productMainCategory?: { __typename?: 'LegacyCategory', slug: string } | null, license?: { __typename?: 'LegacyLicense', ID: number } | null } | null };

export type LegacyProductsListPpeProductsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  categories?: Types.InputMaybe<Array<Types.Category> | Types.Category>;
}>;


export type LegacyProductsListPpeProductsQuery = { __typename?: 'Query', legacyProductsListPPEProducts: { __typename?: 'LegacyPPEResponse', products: Array<{ __typename?: 'LegacyProduct', id: number, slug: string, title: string, image?: string | null, favoriteCount: number, author: { __typename?: 'LegacyAuthor', avatar?: string | null, name?: string | null }, productMainCategory?: { __typename?: 'LegacyCategory', slug: string } | null, license?: { __typename?: 'LegacyLicense', ID: number } | null }>, meta: { __typename?: 'LegacyPPEMeta', total: number, nextOffset: number } } };

export type UserListLegacyAndContentFavoriteProductsQueryVariables = Types.Exact<{
  input: Types.UsersListFavoriteProductsInput;
}>;


export type UserListLegacyAndContentFavoriteProductsQuery = { __typename?: 'Query', userListLegacyAndContentFavoriteProducts: Array<{ __typename?: 'UserListFavoriteProduct', productId: string, productTitle: string, productImage: string, mainCategoryName: string, favoriteCount: number, hasBeenDownloaded: boolean }> };

export type LegacyProductsFavoritesCountQueryVariables = Types.Exact<{
  productIds: Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input'];
}>;


export type LegacyProductsFavoritesCountQuery = { __typename?: 'Query', cfmainProductsFavoritesCount: { __typename?: 'CFMainProductsFavoritesCount', favoritesCounts: Array<{ __typename?: 'CFMainProductsFavoritesCountItem', productId: number, count: number, isFavorite: boolean }> } };

export type LegacyProductsSetFavoriteMutationVariables = Types.Exact<{
  productId: Types.Scalars['Int']['input'];
  isFavorite: Types.Scalars['Boolean']['input'];
}>;


export type LegacyProductsSetFavoriteMutation = { __typename?: 'Mutation', usersFavoriteProduct: { __typename?: 'UsersFavoriteProductResponse', success: boolean, favoriteCount: number } };



export const CachedSiteDataDocument = /*#__PURE__*/ `
    query cachedSiteData($language: Language) {
  cachedSiteData(language: $language) {
    billing
    currencies {
      currencies {
        code
        symbol
      }
      activeCurrency {
        code
        symbol
      }
    }
    allAccessYearlyBanner {
      __typename
      type
      yearly
      buttonUrl
      buttonText
      showInHeader
      backgroundImage
      headline
      features
      bannerAboveNav
      bannerAboveNavState
      isHidden
    }
    allAccessYearlyTrialBanner {
      __typename
      type
      yearly
      buttonUrl
      buttonText
      showInHeader
      backgroundImage
      headline
      features
      bannerAboveNav
      bannerAboveNavState
      isHidden
    }
    promo {
      promotion {
        discount
        name
      }
      takeover {
        aboveNavBannerBtnColor
        aboveNavBannerBtnTextColor
        aboveNavBannerColor
        aboveNavBannerImg
        isActive
      }
    }
  }
}
    `;

export const useCachedSiteDataQuery = <
      TData = CachedSiteDataQuery,
      TError = unknown
    >(
      variables?: CachedSiteDataQueryVariables,
      options?: Omit<UseQueryOptions<CachedSiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CachedSiteDataQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<CachedSiteDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['cachedSiteData'] : ['cachedSiteData', variables],
    queryFn: fetcher<CachedSiteDataQuery, CachedSiteDataQueryVariables>(CachedSiteDataDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useCachedSiteDataQuery.document = CachedSiteDataDocument;

useCachedSiteDataQuery.getKey = (variables?: CachedSiteDataQueryVariables) => variables === undefined ? ['cachedSiteData'] : ['cachedSiteData', variables];

useCachedSiteDataQuery.rootKey = 'cachedSiteData';

export const useSuspenseCachedSiteDataQuery = <
      TData = CachedSiteDataQuery,
      TError = unknown
    >(
      variables?: CachedSiteDataQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<CachedSiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<CachedSiteDataQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<CachedSiteDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['cachedSiteDataSuspense'] : ['cachedSiteDataSuspense', variables],
    queryFn: fetcher<CachedSiteDataQuery, CachedSiteDataQueryVariables>(CachedSiteDataDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseCachedSiteDataQuery.document = CachedSiteDataDocument;

useSuspenseCachedSiteDataQuery.getKey = (variables?: CachedSiteDataQueryVariables) => variables === undefined ? ['cachedSiteDataSuspense'] : ['cachedSiteDataSuspense', variables];

useSuspenseCachedSiteDataQuery.rootKey = 'cachedSiteData';

export const useInfiniteCachedSiteDataQuery = <
      TData = InfiniteData<CachedSiteDataQuery>,
      TError = unknown
    >(
      variables: CachedSiteDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<CachedSiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CachedSiteDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CachedSiteDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['cachedSiteData.infinite'] : ['cachedSiteData.infinite', variables],
      queryFn: (metaData) => fetcher<CachedSiteDataQuery, CachedSiteDataQueryVariables>(CachedSiteDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCachedSiteDataQuery.getKey = (variables?: CachedSiteDataQueryVariables) => variables === undefined ? ['cachedSiteData.infinite'] : ['cachedSiteData.infinite', variables];

useInfiniteCachedSiteDataQuery.rootKey = 'cachedSiteData.infinite';

export const useSuspenseInfiniteCachedSiteDataQuery = <
      TData = InfiniteData<CachedSiteDataQuery>,
      TError = unknown
    >(
      variables: CachedSiteDataQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<CachedSiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<CachedSiteDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<CachedSiteDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['cachedSiteData.infiniteSuspense'] : ['cachedSiteData.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<CachedSiteDataQuery, CachedSiteDataQueryVariables>(CachedSiteDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteCachedSiteDataQuery.getKey = (variables?: CachedSiteDataQueryVariables) => variables === undefined ? ['cachedSiteData.infiniteSuspense'] : ['cachedSiteData.infiniteSuspense', variables];

useSuspenseInfiniteCachedSiteDataQuery.rootKey = 'cachedSiteData.infinite';


useCachedSiteDataQuery.fetcher = (variables?: CachedSiteDataQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<CachedSiteDataQuery, CachedSiteDataQueryVariables>(CachedSiteDataDocument, variables, options, fetchOptions);

export const SiteDataDocument = /*#__PURE__*/ `
    query siteData {
  siteData {
    billing
    isExtensionPopupEnabled {
      enabled
    }
    currencies {
      currencies {
        code
        symbol
      }
      activeCurrency {
        code
        symbol
      }
    }
    productCounts {
      fonts
      crafts
      graphics
      embroidery
    }
    newsletterPopup {
      __typename
      type
      title
      text
      closeText
      footerText
      backgroundImageSrc
      button {
        backgroundColor
        text
        link
      }
    }
    notificationPopup {
      __typename
      type
      backgroundColor
      title
      textColor
      text
      button {
        backgroundColor
        hoverBackgroundColor
        text
        textColor
        hoverTextColor
        link
      }
      countdown {
        text
        value
      }
      closeText
    }
    profileNudgePopup {
      __typename
      type
      title
      text
      button {
        backgroundColor
        text
        link
      }
    }
    awaitingRenewalConfirmationBanner {
      __typename
      type
      backgroundColor
      text
      bannerAboveNav
      bannerAboveNavState
    }
    classesBanner {
      __typename
      type
      text
      fontSize
      lineHeight
      textColor
      backgroundColor
      bannerTitleClass
      hideByDefault
      button {
        backgroundColor
        text
        textColor
        link
      }
    }
    notificationBanner {
      __typename
      type
      backgroundColor
      textColor
      text
      countdown {
        text
        value
      }
      bannerAboveNav
      bannerAboveNavState
      button {
        backgroundColor
        hoverBackgroundColor
        text
        textColor
        hoverTextColor
        link
      }
    }
    onHoldSubscriptionBanner {
      __typename
      type
      backgroundColor
      text
      bannerAboveNav
      bannerAboveNavState
    }
    sparkFreeTrialBanner {
      __typename
      type
      backgroundImage
      text
      subtext
      aboveButtonText
      belowButtonText
      buttonText
      buttonUrl
      bannerAboveNav
      bannerAboveNavState
      bannerIsMinimized
    }
    allAccessBanner {
      __typename
      type
      backgroundColor
      text
      textColor
      bannerAboveNav
      bannerAboveNavState
      bannerAboveNavPromo
      countdown {
        text
        value
      }
      button {
        backgroundColor
        text
        textColor
        hoverTextColor
        link
      }
    }
    undoCancelationBanner {
      __typename
      type
      backgroundColor
      text
      subscriptionId
      bannerAboveNav
      bannerAboveNavState
      button {
        backgroundColor
        text
        textColor
        hoverTextColor
        onClick
        link
      }
      countdown {
        value
        text
      }
    }
    upsellBanner {
      __typename
      type
      backgroundColor
      text
      countdown {
        text
        value
      }
      button {
        backgroundColor
        text
        textColor
        hoverTextColor
        link
      }
    }
    verificationBanner {
      __typename
      type
      backgroundColor
      text
      textColor
      bannerAboveNav
      bannerAboveNavState
      button {
        backgroundColor
        text
        textColor
        link
      }
    }
    allAccessYearlyBanner {
      __typename
      type
      yearly
      buttonUrl
      buttonText
      showInHeader
      backgroundImage
      headline
      features
      bannerAboveNav
      bannerAboveNavState
      isHidden
    }
    allAccessYearlyTrialBanner {
      __typename
      type
      yearly
      buttonUrl
      buttonText
      showInHeader
      backgroundImage
      headline
      features
      bannerAboveNav
      bannerAboveNavState
      isHidden
    }
    studioAiYearlyTrialBanner {
      __typename
      type
      yearly
      buttonUrl
      buttonText
      showInHeader
      backgroundImage
      headline
      features
      bannerAboveNav
      bannerAboveNavState
      isHidden
      variant
    }
    allAccessYearlyExtendBanner {
      __typename
      type
      backgroundImage
      buttonText
      features
      headline
      subscriptionId
      inProgress
      lastOrderPaymentUrl
      countdownDt
      bannerAboveNav
      bannerAboveNavState
    }
    promo {
      promotion {
        discount
        name
      }
      takeover {
        aboveNavBannerBtnColor
        aboveNavBannerBtnTextColor
        aboveNavBannerColor
        aboveNavBannerImg
        isActive
      }
    }
  }
}
    `;

export const useSiteDataQuery = <
      TData = SiteDataQuery,
      TError = unknown
    >(
      variables?: SiteDataQueryVariables,
      options?: Omit<UseQueryOptions<SiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<SiteDataQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<SiteDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['siteData'] : ['siteData', variables],
    queryFn: fetcher<SiteDataQuery, SiteDataQueryVariables>(SiteDataDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSiteDataQuery.document = SiteDataDocument;

useSiteDataQuery.getKey = (variables?: SiteDataQueryVariables) => variables === undefined ? ['siteData'] : ['siteData', variables];

useSiteDataQuery.rootKey = 'siteData';

export const useSuspenseSiteDataQuery = <
      TData = SiteDataQuery,
      TError = unknown
    >(
      variables?: SiteDataQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<SiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<SiteDataQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<SiteDataQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['siteDataSuspense'] : ['siteDataSuspense', variables],
    queryFn: fetcher<SiteDataQuery, SiteDataQueryVariables>(SiteDataDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseSiteDataQuery.document = SiteDataDocument;

useSuspenseSiteDataQuery.getKey = (variables?: SiteDataQueryVariables) => variables === undefined ? ['siteDataSuspense'] : ['siteDataSuspense', variables];

useSuspenseSiteDataQuery.rootKey = 'siteData';

export const useInfiniteSiteDataQuery = <
      TData = InfiniteData<SiteDataQuery>,
      TError = unknown
    >(
      variables: SiteDataQueryVariables,
      options: Omit<UseInfiniteQueryOptions<SiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<SiteDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<SiteDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['siteData.infinite'] : ['siteData.infinite', variables],
      queryFn: (metaData) => fetcher<SiteDataQuery, SiteDataQueryVariables>(SiteDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteSiteDataQuery.getKey = (variables?: SiteDataQueryVariables) => variables === undefined ? ['siteData.infinite'] : ['siteData.infinite', variables];

useInfiniteSiteDataQuery.rootKey = 'siteData.infinite';

export const useSuspenseInfiniteSiteDataQuery = <
      TData = InfiniteData<SiteDataQuery>,
      TError = unknown
    >(
      variables: SiteDataQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<SiteDataQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<SiteDataQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<SiteDataQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['siteData.infiniteSuspense'] : ['siteData.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<SiteDataQuery, SiteDataQueryVariables>(SiteDataDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteSiteDataQuery.getKey = (variables?: SiteDataQueryVariables) => variables === undefined ? ['siteData.infiniteSuspense'] : ['siteData.infiniteSuspense', variables];

useSuspenseInfiniteSiteDataQuery.rootKey = 'siteData.infinite';


useSiteDataQuery.fetcher = (variables?: SiteDataQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<SiteDataQuery, SiteDataQueryVariables>(SiteDataDocument, variables, options, fetchOptions);

export const UpdateUserGdprConsentDocument = /*#__PURE__*/ `
    mutation updateUserGDPRConsent($input: UserUpdateGDPRInput!) {
  updateUserGDPR(input: $input) {
    success
    errors {
      code
      message
    }
  }
}
    `;

export const useUpdateUserGdprConsentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserGdprConsentMutation, TError, UpdateUserGdprConsentMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<UpdateUserGdprConsentMutation, TError, UpdateUserGdprConsentMutationVariables, TContext>(
      {
    mutationKey: ['updateUserGDPRConsent'],
    mutationFn: (variables?: UpdateUserGdprConsentMutationVariables) => fetcher<UpdateUserGdprConsentMutation, UpdateUserGdprConsentMutationVariables>(UpdateUserGdprConsentDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useUpdateUserGdprConsentMutation.getKey = () => ['updateUserGDPRConsent'];


useUpdateUserGdprConsentMutation.fetcher = (variables: UpdateUserGdprConsentMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UpdateUserGdprConsentMutation, UpdateUserGdprConsentMutationVariables>(UpdateUserGdprConsentDocument, variables, options, fetchOptions);

export const LegacyProductFetchProductDocument = /*#__PURE__*/ `
    query legacyProductFetchProduct($productId: Int!) {
  legacyProductsFetchProduct(id: $productId) {
    id
    title
    author {
      avatar
      name
    }
    image
    favoriteCount
    productMainCategory {
      slug
    }
    license {
      ID
    }
  }
}
    `;

export const useLegacyProductFetchProductQuery = <
      TData = LegacyProductFetchProductQuery,
      TError = unknown
    >(
      variables: LegacyProductFetchProductQueryVariables,
      options?: Omit<UseQueryOptions<LegacyProductFetchProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LegacyProductFetchProductQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<LegacyProductFetchProductQuery, TError, TData>(
      {
    queryKey: ['legacyProductFetchProduct', variables],
    queryFn: fetcher<LegacyProductFetchProductQuery, LegacyProductFetchProductQueryVariables>(LegacyProductFetchProductDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useLegacyProductFetchProductQuery.document = LegacyProductFetchProductDocument;

useLegacyProductFetchProductQuery.getKey = (variables: LegacyProductFetchProductQueryVariables) => ['legacyProductFetchProduct', variables];

useLegacyProductFetchProductQuery.rootKey = 'legacyProductFetchProduct';

export const useSuspenseLegacyProductFetchProductQuery = <
      TData = LegacyProductFetchProductQuery,
      TError = unknown
    >(
      variables: LegacyProductFetchProductQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LegacyProductFetchProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LegacyProductFetchProductQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<LegacyProductFetchProductQuery, TError, TData>(
      {
    queryKey: ['legacyProductFetchProductSuspense', variables],
    queryFn: fetcher<LegacyProductFetchProductQuery, LegacyProductFetchProductQueryVariables>(LegacyProductFetchProductDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseLegacyProductFetchProductQuery.document = LegacyProductFetchProductDocument;

useSuspenseLegacyProductFetchProductQuery.getKey = (variables: LegacyProductFetchProductQueryVariables) => ['legacyProductFetchProductSuspense', variables];

useSuspenseLegacyProductFetchProductQuery.rootKey = 'legacyProductFetchProduct';

export const useInfiniteLegacyProductFetchProductQuery = <
      TData = InfiniteData<LegacyProductFetchProductQuery>,
      TError = unknown
    >(
      variables: LegacyProductFetchProductQueryVariables,
      options: Omit<UseInfiniteQueryOptions<LegacyProductFetchProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<LegacyProductFetchProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<LegacyProductFetchProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['legacyProductFetchProduct.infinite', variables],
      queryFn: (metaData) => fetcher<LegacyProductFetchProductQuery, LegacyProductFetchProductQueryVariables>(LegacyProductFetchProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteLegacyProductFetchProductQuery.getKey = (variables: LegacyProductFetchProductQueryVariables) => ['legacyProductFetchProduct.infinite', variables];

useInfiniteLegacyProductFetchProductQuery.rootKey = 'legacyProductFetchProduct.infinite';

export const useSuspenseInfiniteLegacyProductFetchProductQuery = <
      TData = InfiniteData<LegacyProductFetchProductQuery>,
      TError = unknown
    >(
      variables: LegacyProductFetchProductQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<LegacyProductFetchProductQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<LegacyProductFetchProductQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<LegacyProductFetchProductQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['legacyProductFetchProduct.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<LegacyProductFetchProductQuery, LegacyProductFetchProductQueryVariables>(LegacyProductFetchProductDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteLegacyProductFetchProductQuery.getKey = (variables: LegacyProductFetchProductQueryVariables) => ['legacyProductFetchProduct.infiniteSuspense', variables];

useSuspenseInfiniteLegacyProductFetchProductQuery.rootKey = 'legacyProductFetchProduct.infinite';


useLegacyProductFetchProductQuery.fetcher = (variables: LegacyProductFetchProductQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<LegacyProductFetchProductQuery, LegacyProductFetchProductQueryVariables>(LegacyProductFetchProductDocument, variables, options, fetchOptions);

export const LegacyProductsListPpeProductsDocument = /*#__PURE__*/ `
    query legacyProductsListPPEProducts($limit: Int!, $offset: Int, $categories: [Category!]) {
  legacyProductsListPPEProducts(
    input: {limit: $limit, offset: $offset, categories: $categories}
  ) {
    products {
      id
      slug
      title
      author {
        avatar
        name
      }
      image
      favoriteCount
      productMainCategory {
        slug
      }
      license {
        ID
      }
    }
    meta {
      total
      nextOffset
    }
  }
}
    `;

export const useLegacyProductsListPpeProductsQuery = <
      TData = LegacyProductsListPpeProductsQuery,
      TError = unknown
    >(
      variables: LegacyProductsListPpeProductsQueryVariables,
      options?: Omit<UseQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<LegacyProductsListPpeProductsQuery, TError, TData>(
      {
    queryKey: ['legacyProductsListPPEProducts', variables],
    queryFn: fetcher<LegacyProductsListPpeProductsQuery, LegacyProductsListPpeProductsQueryVariables>(LegacyProductsListPpeProductsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useLegacyProductsListPpeProductsQuery.document = LegacyProductsListPpeProductsDocument;

useLegacyProductsListPpeProductsQuery.getKey = (variables: LegacyProductsListPpeProductsQueryVariables) => ['legacyProductsListPPEProducts', variables];

useLegacyProductsListPpeProductsQuery.rootKey = 'legacyProductsListPPEProducts';

export const useSuspenseLegacyProductsListPpeProductsQuery = <
      TData = LegacyProductsListPpeProductsQuery,
      TError = unknown
    >(
      variables: LegacyProductsListPpeProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<LegacyProductsListPpeProductsQuery, TError, TData>(
      {
    queryKey: ['legacyProductsListPPEProductsSuspense', variables],
    queryFn: fetcher<LegacyProductsListPpeProductsQuery, LegacyProductsListPpeProductsQueryVariables>(LegacyProductsListPpeProductsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseLegacyProductsListPpeProductsQuery.document = LegacyProductsListPpeProductsDocument;

useSuspenseLegacyProductsListPpeProductsQuery.getKey = (variables: LegacyProductsListPpeProductsQueryVariables) => ['legacyProductsListPPEProductsSuspense', variables];

useSuspenseLegacyProductsListPpeProductsQuery.rootKey = 'legacyProductsListPPEProducts';

export const useInfiniteLegacyProductsListPpeProductsQuery = <
      TData = InfiniteData<LegacyProductsListPpeProductsQuery>,
      TError = unknown
    >(
      variables: LegacyProductsListPpeProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<LegacyProductsListPpeProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['legacyProductsListPPEProducts.infinite', variables],
      queryFn: (metaData) => fetcher<LegacyProductsListPpeProductsQuery, LegacyProductsListPpeProductsQueryVariables>(LegacyProductsListPpeProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteLegacyProductsListPpeProductsQuery.getKey = (variables: LegacyProductsListPpeProductsQueryVariables) => ['legacyProductsListPPEProducts.infinite', variables];

useInfiniteLegacyProductsListPpeProductsQuery.rootKey = 'legacyProductsListPPEProducts.infinite';

export const useSuspenseInfiniteLegacyProductsListPpeProductsQuery = <
      TData = InfiniteData<LegacyProductsListPpeProductsQuery>,
      TError = unknown
    >(
      variables: LegacyProductsListPpeProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<LegacyProductsListPpeProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<LegacyProductsListPpeProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['legacyProductsListPPEProducts.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<LegacyProductsListPpeProductsQuery, LegacyProductsListPpeProductsQueryVariables>(LegacyProductsListPpeProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteLegacyProductsListPpeProductsQuery.getKey = (variables: LegacyProductsListPpeProductsQueryVariables) => ['legacyProductsListPPEProducts.infiniteSuspense', variables];

useSuspenseInfiniteLegacyProductsListPpeProductsQuery.rootKey = 'legacyProductsListPPEProducts.infinite';


useLegacyProductsListPpeProductsQuery.fetcher = (variables: LegacyProductsListPpeProductsQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<LegacyProductsListPpeProductsQuery, LegacyProductsListPpeProductsQueryVariables>(LegacyProductsListPpeProductsDocument, variables, options, fetchOptions);

export const UserListLegacyAndContentFavoriteProductsDocument = /*#__PURE__*/ `
    query userListLegacyAndContentFavoriteProducts($input: UsersListFavoriteProductsInput!) {
  userListLegacyAndContentFavoriteProducts(input: $input) {
    productId
    productTitle
    productImage
    mainCategoryName
    favoriteCount
    hasBeenDownloaded
  }
}
    `;

export const useUserListLegacyAndContentFavoriteProductsQuery = <
      TData = UserListLegacyAndContentFavoriteProductsQuery,
      TError = unknown
    >(
      variables: UserListLegacyAndContentFavoriteProductsQueryVariables,
      options?: Omit<UseQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>(
      {
    queryKey: ['userListLegacyAndContentFavoriteProducts', variables],
    queryFn: fetcher<UserListLegacyAndContentFavoriteProductsQuery, UserListLegacyAndContentFavoriteProductsQueryVariables>(UserListLegacyAndContentFavoriteProductsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useUserListLegacyAndContentFavoriteProductsQuery.document = UserListLegacyAndContentFavoriteProductsDocument;

useUserListLegacyAndContentFavoriteProductsQuery.getKey = (variables: UserListLegacyAndContentFavoriteProductsQueryVariables) => ['userListLegacyAndContentFavoriteProducts', variables];

useUserListLegacyAndContentFavoriteProductsQuery.rootKey = 'userListLegacyAndContentFavoriteProducts';

export const useSuspenseUserListLegacyAndContentFavoriteProductsQuery = <
      TData = UserListLegacyAndContentFavoriteProductsQuery,
      TError = unknown
    >(
      variables: UserListLegacyAndContentFavoriteProductsQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>(
      {
    queryKey: ['userListLegacyAndContentFavoriteProductsSuspense', variables],
    queryFn: fetcher<UserListLegacyAndContentFavoriteProductsQuery, UserListLegacyAndContentFavoriteProductsQueryVariables>(UserListLegacyAndContentFavoriteProductsDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseUserListLegacyAndContentFavoriteProductsQuery.document = UserListLegacyAndContentFavoriteProductsDocument;

useSuspenseUserListLegacyAndContentFavoriteProductsQuery.getKey = (variables: UserListLegacyAndContentFavoriteProductsQueryVariables) => ['userListLegacyAndContentFavoriteProductsSuspense', variables];

useSuspenseUserListLegacyAndContentFavoriteProductsQuery.rootKey = 'userListLegacyAndContentFavoriteProducts';

export const useInfiniteUserListLegacyAndContentFavoriteProductsQuery = <
      TData = InfiniteData<UserListLegacyAndContentFavoriteProductsQuery>,
      TError = unknown
    >(
      variables: UserListLegacyAndContentFavoriteProductsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userListLegacyAndContentFavoriteProducts.infinite', variables],
      queryFn: (metaData) => fetcher<UserListLegacyAndContentFavoriteProductsQuery, UserListLegacyAndContentFavoriteProductsQueryVariables>(UserListLegacyAndContentFavoriteProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUserListLegacyAndContentFavoriteProductsQuery.getKey = (variables: UserListLegacyAndContentFavoriteProductsQueryVariables) => ['userListLegacyAndContentFavoriteProducts.infinite', variables];

useInfiniteUserListLegacyAndContentFavoriteProductsQuery.rootKey = 'userListLegacyAndContentFavoriteProducts.infinite';

export const useSuspenseInfiniteUserListLegacyAndContentFavoriteProductsQuery = <
      TData = InfiniteData<UserListLegacyAndContentFavoriteProductsQuery>,
      TError = unknown
    >(
      variables: UserListLegacyAndContentFavoriteProductsQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<UserListLegacyAndContentFavoriteProductsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['userListLegacyAndContentFavoriteProducts.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<UserListLegacyAndContentFavoriteProductsQuery, UserListLegacyAndContentFavoriteProductsQueryVariables>(UserListLegacyAndContentFavoriteProductsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteUserListLegacyAndContentFavoriteProductsQuery.getKey = (variables: UserListLegacyAndContentFavoriteProductsQueryVariables) => ['userListLegacyAndContentFavoriteProducts.infiniteSuspense', variables];

useSuspenseInfiniteUserListLegacyAndContentFavoriteProductsQuery.rootKey = 'userListLegacyAndContentFavoriteProducts.infinite';


useUserListLegacyAndContentFavoriteProductsQuery.fetcher = (variables: UserListLegacyAndContentFavoriteProductsQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<UserListLegacyAndContentFavoriteProductsQuery, UserListLegacyAndContentFavoriteProductsQueryVariables>(UserListLegacyAndContentFavoriteProductsDocument, variables, options, fetchOptions);

export const LegacyProductsFavoritesCountDocument = /*#__PURE__*/ `
    query legacyProductsFavoritesCount($productIds: [Int!]!) {
  cfmainProductsFavoritesCount(productIds: $productIds) {
    favoritesCounts {
      productId
      count
      isFavorite
    }
  }
}
    `;

export const useLegacyProductsFavoritesCountQuery = <
      TData = LegacyProductsFavoritesCountQuery,
      TError = unknown
    >(
      variables: LegacyProductsFavoritesCountQueryVariables,
      options?: Omit<UseQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useQuery<LegacyProductsFavoritesCountQuery, TError, TData>(
      {
    queryKey: ['legacyProductsFavoritesCount', variables],
    queryFn: fetcher<LegacyProductsFavoritesCountQuery, LegacyProductsFavoritesCountQueryVariables>(LegacyProductsFavoritesCountDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useLegacyProductsFavoritesCountQuery.document = LegacyProductsFavoritesCountDocument;

useLegacyProductsFavoritesCountQuery.getKey = (variables: LegacyProductsFavoritesCountQueryVariables) => ['legacyProductsFavoritesCount', variables];

useLegacyProductsFavoritesCountQuery.rootKey = 'legacyProductsFavoritesCount';

export const useSuspenseLegacyProductsFavoritesCountQuery = <
      TData = LegacyProductsFavoritesCountQuery,
      TError = unknown
    >(
      variables: LegacyProductsFavoritesCountQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>['queryKey'] },
      headers?: Headers, fetchOptions?: FetchOptions
    ) => {
    
    return useSuspenseQuery<LegacyProductsFavoritesCountQuery, TError, TData>(
      {
    queryKey: ['legacyProductsFavoritesCountSuspense', variables],
    queryFn: fetcher<LegacyProductsFavoritesCountQuery, LegacyProductsFavoritesCountQueryVariables>(LegacyProductsFavoritesCountDocument, variables, headers, fetchOptions),
    ...options
  }
    )};

useSuspenseLegacyProductsFavoritesCountQuery.document = LegacyProductsFavoritesCountDocument;

useSuspenseLegacyProductsFavoritesCountQuery.getKey = (variables: LegacyProductsFavoritesCountQueryVariables) => ['legacyProductsFavoritesCountSuspense', variables];

useSuspenseLegacyProductsFavoritesCountQuery.rootKey = 'legacyProductsFavoritesCount';

export const useInfiniteLegacyProductsFavoritesCountQuery = <
      TData = InfiniteData<LegacyProductsFavoritesCountQuery>,
      TError = unknown
    >(
      variables: LegacyProductsFavoritesCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<LegacyProductsFavoritesCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['legacyProductsFavoritesCount.infinite', variables],
      queryFn: (metaData) => fetcher<LegacyProductsFavoritesCountQuery, LegacyProductsFavoritesCountQueryVariables>(LegacyProductsFavoritesCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteLegacyProductsFavoritesCountQuery.getKey = (variables: LegacyProductsFavoritesCountQueryVariables) => ['legacyProductsFavoritesCount.infinite', variables];

useInfiniteLegacyProductsFavoritesCountQuery.rootKey = 'legacyProductsFavoritesCount.infinite';

export const useSuspenseInfiniteLegacyProductsFavoritesCountQuery = <
      TData = InfiniteData<LegacyProductsFavoritesCountQuery>,
      TError = unknown
    >(
      variables: LegacyProductsFavoritesCountQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<LegacyProductsFavoritesCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<LegacyProductsFavoritesCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['legacyProductsFavoritesCount.infiniteSuspense', variables],
      queryFn: (metaData) => fetcher<LegacyProductsFavoritesCountQuery, LegacyProductsFavoritesCountQueryVariables>(LegacyProductsFavoritesCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useSuspenseInfiniteLegacyProductsFavoritesCountQuery.getKey = (variables: LegacyProductsFavoritesCountQueryVariables) => ['legacyProductsFavoritesCount.infiniteSuspense', variables];

useSuspenseInfiniteLegacyProductsFavoritesCountQuery.rootKey = 'legacyProductsFavoritesCount.infinite';


useLegacyProductsFavoritesCountQuery.fetcher = (variables: LegacyProductsFavoritesCountQueryVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<LegacyProductsFavoritesCountQuery, LegacyProductsFavoritesCountQueryVariables>(LegacyProductsFavoritesCountDocument, variables, options, fetchOptions);

export const LegacyProductsSetFavoriteDocument = /*#__PURE__*/ `
    mutation legacyProductsSetFavorite($productId: Int!, $isFavorite: Boolean!) {
  usersFavoriteProduct(productID: $productId, isFavorite: $isFavorite) {
    success
    favoriteCount
  }
}
    `;

export const useLegacyProductsSetFavoriteMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LegacyProductsSetFavoriteMutation, TError, LegacyProductsSetFavoriteMutationVariables, TContext>, headers?: Headers, fetchOptions?: FetchOptions) => {
    
    return useMutation<LegacyProductsSetFavoriteMutation, TError, LegacyProductsSetFavoriteMutationVariables, TContext>(
      {
    mutationKey: ['legacyProductsSetFavorite'],
    mutationFn: (variables?: LegacyProductsSetFavoriteMutationVariables) => fetcher<LegacyProductsSetFavoriteMutation, LegacyProductsSetFavoriteMutationVariables>(LegacyProductsSetFavoriteDocument, variables, headers, fetchOptions)(),
    ...options
  }
    )};

useLegacyProductsSetFavoriteMutation.getKey = () => ['legacyProductsSetFavorite'];


useLegacyProductsSetFavoriteMutation.fetcher = (variables: LegacyProductsSetFavoriteMutationVariables, options?: RequestInit['headers'], fetchOptions?: FetchOptions) => fetcher<LegacyProductsSetFavoriteMutation, LegacyProductsSetFavoriteMutationVariables>(LegacyProductsSetFavoriteDocument, variables, options, fetchOptions);
